import { RootState } from "../../../redux-store";

export const selectHideLoadmeters = (state: RootState) =>
  state.data.driverAppSettings.hideLoadmeters;
